import LocomotiveScroll from 'locomotive-scroll';
import { $scroll } from '../stores/scroll';
import { $html } from '../utils/dom';

export class Scroll {
  static lastProgress = 0;
  static scrollOrientation = 0;

  // =============================================================================
  // Lifecycle
  // =============================================================================
  static init() {
    this.locomotiveScroll = new LocomotiveScroll({
      scrollCallback({ scroll, limit, velocity, direction, progress }) {
        $scroll.set({
          scroll,
          limit,
          velocity,
          direction,
          progress
        });

        if (scroll > 20) {
          $html.classList.add('has-scrolled');
        } else {
          $html.classList.remove('has-scrolled');
        }

        if (progress > this.lastProgress && this.scrollOrientation != 1) {
          this.scrollOrientation = 1;
          document.documentElement.classList.add('scrolling-down');
        } else if (progress < this.lastProgress && this.scrollOrientation != -1) {
          this.scrollOrientation = -1;
          document.documentElement.classList.remove('scrolling-down');
        }

        this.lastProgress = progress;
      }
    });

    this.locomotiveScroll.lenisInstance.options.content.addEventListener('wheel', event => {
      const targets = event.composedPath();

      const stopPropagation = targets.some(target => target.id === 'cc-main');
      if (stopPropagation) {
        event.stopPropagation();
      }
    });
  }

  static destroy() {
    this.locomotiveScroll?.destroy();
  }

  // =============================================================================
  // Methods
  // =============================================================================
  /**
   * Жёстко сбрасывает скролл в начало сразу (без анимации),
   * чтобы при переходах (Swup) новый контент не "наследовал" позицию со старой страницы.
  //  */
  // static resetToTop() {
  //   // На всякий случай синхронизируем нативный scrollTop
  //   // window.scrollTo(0, 0);

  //   // И синхронизируем Lenis/Locomotive (важно: force=true даже если stopped)
  //   // this.locomotiveScroll?.scrollTo(0, { immediate: true, force: true });

  //   // Сбрасываем локальные стейты
  //   this.lastProgress = 0;
  //   this.scrollOrientation = 0;
  //   document.documentElement.classList.remove('scrolling-down');
  //   $html.classList.remove('has-scrolled');
  // }
  static start() {
    this.locomotiveScroll?.start();
  }

  static stop() {
    this.locomotiveScroll?.stop();
  }

  static addScrollElements(container) {
    this.locomotiveScroll?.addScrollElements(container);
  }

  static removeScrollElements(container) {
    this.locomotiveScroll?.removeScrollElements(container);
  }

  static scrollTo(target, options) {
    console.log('scrollTo', target, options);
    this.locomotiveScroll?.scrollTo(target, options);
  }
}
